
import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from "@/UI/components/header/Header.vue";
import SideBar from "@/UI/components/sideBar/SideBar.vue";
import Breadcrumb from "@/UI/components/common/Breadcrumb.vue";
import { Layout } from 'ant-design-vue'
import { AuthStore } from '@/store/modules/Auth';
import CompanySubscription from '@/UI/components/common/CompanySubscription.vue';

@Component({
  components: {
    CompanySubscription,
    Breadcrumb,
    SideBar,
    Header,
    'a-layout': Layout,
    'a-layout-content': Layout.Content
  }
})
export default class MainLayout extends Vue {
    //UserRole = getUserRole()
    UserRole = {}
    menuOpen = false
    menuTrigger: HTMLElement | null = null
    darkTheme = document.documentElement.getAttribute('data-pult-theme') === 'dark'

    toggleTheme(): void {
        this.darkTheme = !this.darkTheme;
        const theme = this.darkTheme ? 'dark' : 'light';
        document.documentElement.setAttribute('data-pult-theme', theme);
        try { localStorage.setItem('pult-theme', theme); } catch (e) { /* Theme remains usable without storage. */ }
    }

    @Watch('menuOpen')
    syncMenuScroll(): void {
        document.body.classList.toggle('pult-nav-open', this.menuOpen);
        if (this.menuOpen) {
            this.menuTrigger = document.activeElement as HTMLElement;
            this.$nextTick(() => {
                const firstLink = this.$el.querySelector<HTMLElement>('#pult-navigation a');
                if (firstLink) firstLink.focus();
            });
        } else if (this.menuTrigger) {
            this.menuTrigger.focus();
        }
    }

    @Watch('$route.fullPath')
    closeMenu(): void { this.menuOpen = false; }

    mounted(): void { window.addEventListener('keydown', this.handleMenuKey); }
    beforeDestroy(): void {
        window.removeEventListener('keydown', this.handleMenuKey);
        document.body.classList.remove('pult-nav-open');
    }
    handleMenuKey(event: KeyboardEvent): void {
        if (!this.menuOpen) return;
        if (event.key === 'Escape') this.menuOpen = false;
        if (event.key === 'Tab') {
            const links = this.$el.querySelectorAll<HTMLElement>('#pult-navigation a, #pult-navigation [role="menuitem"][tabindex="0"]');
            const first = links[0];
            const last = links[links.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
    }


    get UserData():any{
        return AuthStore.userData
    }
    @Watch('$store.auth.userData', { immediate: true })
    UserProps():void {

        this.UserRole = this.UserData
    }

    @Watch('$route.name')
    onChangeRoute(): void {

        //console.log('------- Get user role layout -'+ getUserRole)
        window.scrollTo(0,0);
  }
  created():void{
      //console.log('------- Get user role layout -'+ this.UserRole)
  }
}
